import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useDispatch } from "react-redux";
import FullScreenLoader from "./component/FullScreenLoader/fullScreenLoader";
import AppRouter from "./component/AppRouter";
import jwtEncode from "jwt-encode";
import { jwtDecode } from "jwt-decode";
import { applicationId, UNO_URL } from "./env";
import axios from "axios";
import { saveConfig } from "./store/slice/configSlice";
import { saveUserData, saveEventUser } from "./store/slice/userSlice";
import { myApplicationList } from "./store/slice/applicationSlice";
import { AUTH_TOKEN } from "../src/utils/common";

function App() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const getConfiguration = async () => {
    setLoading(true);
    await axios
      .get(`${UNO_URL}/api/application/configuration/${applicationId}`)
      .then((response) => {
        const data = response.data.data.data;
        if (!data) return;
        // data.API_URL = "http://localhost:3333"; 
        // data.UNO_URL = "http://localhost:9002";
        dispatch(saveConfig({ data }));
        getUserDetail(data);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const getUserDetail = async (config) => {
    const urlParams = new URLSearchParams(window.location.search);
    const _tokenParam = urlParams.get("referrer");
    let token = "";
    // console.log( _tokenParam,' _tokenParam')
    var initialPath = null;
    if (_tokenParam) {
      const decoded = jwtDecode(_tokenParam);
      localStorage.setItem(AUTH_TOKEN, decoded.token);
      token = decoded.token;
      initialPath = decoded.redirectUri;
    } else if (localStorage.getItem(AUTH_TOKEN)) {
      token = localStorage.getItem(AUTH_TOKEN);
    }

    try {
      let response = await axios.get(`${config.UNO_URL}/api/user/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        localStorage.setItem(AUTH_TOKEN, response.data.data.token);
        const data = {
          token: response.data.data.token,
          user: response.data.data.user,
        };
        dispatch(saveUserData(data));
        fetchApplication(token, config); 
        getChannelUsersList(config, token,data.user.group.uuid);
      }
    } catch (error) {
      localStorage.clear();
      sessionStorage.clear();
      const payload = {
        origin: window.location.origin,
        redirectUri: window.location.pathname,
      };
      const token = jwtEncode(payload, "");
      if (!window.location.pathname.includes("/public")) {
        return (window.location.href = `${config.redirectUri}?referrer=${token}`);
      }
      setLoading(false);
    } 
  };
  const fetchApplication = async (token, config) => {
    try {
      var { data } = await axios.get(`${config.UNO_URL}/api/application/mine`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(myApplicationList(data.data));
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getChannelUsersList = async (config, token,groupId) => {
    try {
      let { data } = await axios.get(`${config.UNO_URL}/api/user/list/${groupId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      let groupData = await axios.get(`${config.UNO_URL}/api/user/group/list/${groupId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      groupData=groupData.data.data?.map((e) => {
        let data = {
          name: e.name,
          groupId: e.uuid,
          avatar: e.avatar,
        };
        return data;
      });
      let combineData = [...data?.data, ...groupData];
      dispatch(saveEventUser(combineData));
    } catch (error) {
      console.error(error);
    } 
  };

  useEffect(() => {
    getConfiguration();
  }, []);
  return (
    <>
      {loading ? (
        <FullScreenLoader />
      ) : (
        <Router>
          <div className="main">
            <AppRouter />
          </div>
        </Router>
      )}
    </>
  );
}

export default App;
